import axios from "axios";

export default function getBranchesInGroup(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/account/api/v1/branch-group/get-branch-in-group?branch_group_uuid=${uuid}`
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
